import React, { Fragment, useState, useEffect, Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import PatientInfo from './PatientInfo';
import Tabbar from './Tabbar';
import DiagnosisInfo from './PatientTreatmentInfo/Diagnosis';
import MedicalReport from './PatientTreatmentInfo/MedicalReport';
import Payment from './PatientTreatmentInfo/Payment';
import { Breadcrumbs } from '../../../../AbstractElements';
import Loader from '../../../../Layout/Loader';
import Prescription from './PatientTreatmentInfo/Prescription';
import Summary from './PatientTreatmentInfo/Summary';
import TreatmentPlan from './PatientTreatmentInfo/TreatmentPlan';
import Notes from './PatientsNotes';
import AddNotes from './Notes';
import { roles_permissions } from '../../../../Layout/Sidebar/Menu';

const PatientPage = () => {
  const [currentTab, setCurrentTab] = useState('summary');
  // const [data, setData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    'diagnosis',
    'treatment-plan',
    'summary',
    'medical-report',
    'prescription',
    'payment',
    // 'view-notes'
  ];

  const permissionsMapping = {
    diagnosis: "PD Diagnosis",
    'treatment-plan': "PD Treatment Plan",
    summary: "PD Summary",
    'medical-report': "PD Medical Report",
    prescription: "PD Prescription",
    payment: "PD Payment",
  };

  const filteredTabs = tabs.filter((tab) => {
    const permission = roles_permissions.find(
      (role) => role.module_name === permissionsMapping[tab]
    );
    return permission?.view_access;
  });
  

  useEffect(() => {
    const tab = location.pathname.split('/').pop();
    setCurrentTab(tab);
  }, [location]);

  const { data } = location.state || {};

  console.log(data)

  const handleTabChange = (tab) => {
        navigate(`/patientinfo/${tab}`,  { state: { data }});
        setCurrentTab(tab);
      };

  const renderTabContent = () => {
    if (!data) {
      return <div>No data available</div>; 
    }

    const permission = roles_permissions.find(
      (role) => role.module_name === permissionsMapping[currentTab]
    );
    switch (currentTab) {
      case 'diagnosis':
        return <div><DiagnosisInfo permission={permission}/></div>;
      case 'treatment-plan':
        return <div><TreatmentPlan permission={permission} /></div>;
      case 'summary':
        return <div><Summary permission={permission}/></div>;
      case 'medical-report':
        return <div><MedicalReport permission={permission} /></div>;
      case 'prescription':
        return <div><Prescription permission={permission}/></div>;
      case 'payment':
        return <div><Payment permission={permission}/></div>;
      case 'view-notes':
        return <div><Notes permission={permission}/></div>;
      default:
        return null;
    }
  };

  return (
    <Suspense fallback={<Loader/>}>

      <Breadcrumbs mainTitle='Patient Info' parent='Patient' title='patientinfo' />
      <div className="page" id="page">
        <PatientInfo data={data} />
        {/* <div>
          <AddNotes/>
        </div> */}
        <div className="page-info-wrapper">
          <Tabbar
            tabs={filteredTabs}
            // tabs={['diagnosis', 'treatment-plan', 'summary', 'medical-report', 'prescription', 'payment', 'view-notes']}
            currentTab={currentTab}
            onTabChange={handleTabChange}
          />
          <div className="page-info-body">
            <TransitionGroup>
              <CSSTransition
                key={currentTab}
                timeout={100}
                classNames="fade"
                unmountOnExit
              >
                <div>
                  {renderTabContent()}
                </div>
              </CSSTransition>
            </TransitionGroup>
          </div>
        </div>
      </div>
      {/* <ToastContainer /> */}
    </Suspense>
  );
};

export default PatientPage;
